import { useState, useRef, useEffect, FC, forwardRef, useImperativeHandle } from "react";
import { Icon } from "../../parts/Icon";
import { Callback, DialogData, DialogId, DialogName } from "../../types";
import { useApp } from "../../context/useApp";

import { ZoneDialog } from "./ZoneDialog";
import { SurchargeDialog } from "./SurchargeDialog";
import { SelectShiftFirstDialog } from "./SelectShiftFirstDialog";
import { ProductDialog } from "./ProductDialog";
import { AddChildrenDialog } from "./AddChildrenDialog";
import { MaxChildrenDialog } from "./MaxChildrenDialog";
import { LoadingDialog } from "./LoadingDialog";
import { ErrorDialog } from "./ErrorDialog";
import { UnassignedSeatsDialog } from "./UnassignedSeatsDialog";
import { CamDialog } from "./CamDialog";

export interface DialogProps {
    id: DialogId
    availableDialogs?: DialogName[]
}

export const Dialog:FC<DialogProps>  = ({id, availableDialogs = []}) => {

    const {
        actions: { addDialogHandle }
    } = useApp()
    const [dialogData, setDialogData] = useState<null | DialogData>(null)
    const dialog = useRef<HTMLDialogElement | null>(null)

    const closeDialog = (callback?: Callback<DialogData>) => {
        if (!dialog.current) return
        if (callback && dialogData) callback(dialogData)
            setDialogData(null)
        dialog.current.open = false
    }
    
    const openDialog = (data: DialogData) => {
        if (
            !dialog.current ||
            (availableDialogs.length > 0 && !availableDialogs.includes(data.dialog))
        ) return
        setDialogData(data)
        dialog.current.open = true
    }

    useEffect(() => {
        addDialogHandle(id, {openDialog, closeDialog})
    },[])

    useEffect(() => {
        if (dialogData) {
            const button: HTMLButtonElement | null = dialog.current?.querySelector('button') ?? null
            if (button) button.focus()
        }
    }, [dialogData]) 

    return (
        <>
        <dialog ref={dialog} open={false} className={`p-a dialog ${dialogData && dialogData.className ? dialogData.className : ''}`} role="dialog">
            {   dialogData && (
                <>
                {   (availableDialogs.includes('zone') || availableDialogs.length === 0) && (
                    <ZoneDialog dialogData={dialogData}/>
                )}
                {   (availableDialogs.includes('surcharge') || availableDialogs.length === 0) && (
                    <SurchargeDialog dialogData={dialogData}/>
                )}
                {   (availableDialogs.includes('select-shift-first') || availableDialogs.length === 0) && (
                    <SelectShiftFirstDialog dialogData={dialogData}/>
                )}
                {   (availableDialogs.includes('product') || availableDialogs.length === 0) && (
                    <ProductDialog dialogData={dialogData}/>
                )}
                {   (availableDialogs.includes('add-children') || availableDialogs.length === 0) && (
                    <AddChildrenDialog dialogData={dialogData}/>
                )}
                {   (availableDialogs.includes('max-children') || availableDialogs.length === 0) && (
                    <MaxChildrenDialog dialogData={dialogData}/>
                )}
                {   (availableDialogs.includes('loading') || availableDialogs.length === 0) && (
                    <LoadingDialog dialogData={dialogData}/>
                )}
                {   (availableDialogs.includes('error') || availableDialogs.length === 0) && (
                    <ErrorDialog dialogData={dialogData}/>
                )}
                {   (availableDialogs.includes('unassigned-seats') || availableDialogs.length === 0) && (
                    <UnassignedSeatsDialog dialogData={dialogData}/>
                )}
                {   (availableDialogs.includes('cam') || availableDialogs.length === 0) && (
                    <CamDialog dialogData={dialogData}/>
                )}
                </>
            )}
        </dialog>
        <div className="p-a dialog-bg w-100 h-100" aria-hidden></div>
        </>
    )
}